import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { CompanyService } from './../../service/company.service'
import { ApplicationService } from './../../service/application.service'

const AddApplication = (params) => {
    const [companies, setCompanies] = useState([]);
    const [applications, setApplications] = useState([]);
    const [message, setMessage] = useState('');

    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [selectedApplications, setSelectedApplications] = useState();
    
    const companyService = new CompanyService();
    const applicationService = new ApplicationService();


    useEffect(() => {
        const fetchData = async () => {
            const appData = await applicationService.getApplications();

            let aData = appData.data.map(function (a) {
                return { value: a.id, label: a.name };
            });
            setApplications(aData);

            const comData = await companyService.getCompanyOnly();
            let cData = comData.data.map(function (a) {
                return { value: a.id, label: a.name };
            });
            setCompanies(cData);
        }

        fetchData()
            .catch(console.error);
    }, []);


    const selectApplication = (e) => {
        setSelectedApplications(e);
        setMessage("");
    };

    const onSuccess = () => {
        if (checkSelection() == true) {
            params.callBack(selectedApplications, selectedCompanies);
            params.onClose();
        }
    };

    const checkSelection = () => {
        if (selectedApplications === undefined) {
            setMessage("No application is selected");
            return false;
        }
        return true;
    };

    return (
        <div className="card" style={{ maxWidth: "500px", minWidth:"350px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Add User
            </h5>
            <div className="card-body">
                {
                    message.length ? <div style={{color: "red", margin:"10px"} }>{message}</div> : ""
                }
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                        <div>
                            <label>Application</label>
                            <Select options={applications} value={selectedApplications} onChange={(e) => selectApplication(e)} />
                        </div>

                        <div style={{ marginTop: "10px" }}>
                            <label>Companies</label>
                            <Select options={companies} isMulti value={selectedCompanies} onChange={(e) => setSelectedCompanies(e)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-secondary" onClick={onSuccess}>Save</button>
                    <button style={{ marginLeft: "5px" }} className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default AddApplication;